<template>
  <div class="profile-list-item" :class="{ editMode: isEditing }">
    <template
      v-if="fields && fields.url && fields.url.value.href && fields.url.value.href.length > 0"
    >
      <sc-link class="profile-list-item__link" v-if="fields && fields.url" :field="fields.url">
        <span
          class="profile-list-item__image"
          :class="{ editMode: isEditing }"
          v-if="fields && fields.image"
        >
          <sc-image v-if="fields && fields.image" :media="fields.image" />
        </span>
        <span class="profile-list-item__content">
          <sc-text
            class="profile-list-item__name"
            v-if="fields && fields.name"
            :field="fields.name"
          />
          <sc-text
            class="profile-list-item__title"
            v-if="fields && fields.title"
            :field="fields.title"
          />
          <sc-text
            class="profile-list-item__company"
            v-if="fields && fields.company"
            :field="fields.company"
          />
        </span>
      </sc-link>
    </template>
    <template v-else>
      <div class="profile-list-item__item">
        <span
          class="profile-list-item__image"
          :class="{ editMode: isEditing }"
          v-if="fields && fields.image"
        >
          <sc-image v-if="fields && fields.image" :media="fields.image" />
        </span>
        <span class="profile-list-item__content">
          <sc-text
            class="profile-list-item__name"
            v-if="fields && fields.name"
            :field="fields.name"
          />
          <sc-text
            class="profile-list-item__title"
            v-if="fields && fields.title"
            :field="fields.title"
          />
          <sc-text
            class="profile-list-item__company"
            v-if="fields && fields.company"
            :field="fields.company"
          />
        </span>
      </div>
    </template>
  </div>
</template>

<script>
import { Image, Text, Link } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Profile-List-Item',
  components: {
    ScText: Text,
    ScImage: Image,
    ScLink: Link
  },
  props: {
    fields: {
      type: Object
    }
  },
  computed: {
    isEditing() {
      return this.$jss.sitecoreContext().pageEditing;
    }
  }
};
</script>
<style lang="scss" scoped>
.profile-list-item {
  margin-bottom: 5rem;

  @include tablet-up {
    width: calc(100% / 3);
  }

  &__link,
  &__item {
    display: flex;
    flex-direction: column;
  }

  &__link {
    line-height: 0;
    font-size: 0;
    color: transparent;
  }

  &__image {
    margin: 1.6rem 6rem 2rem 6rem;

    img {
      width: 100%;
      height: auto;
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
    margin: 0 2.5rem;
    text-align: center;
  }

  &__name {
    @include font-styles('Arial', 2rem, 300, normal, 2.4rem, 0, $blue);
    margin-bottom: 1.2rem;

    @include desktop-up {
      font-size: 2.4rem;
      line-height: 2.8rem;
    }
  }

  &__title {
    @include font-styles('Arial', 1.6rem, 500, normal, 2.2rem, 0, $dark-blue);
    margin-bottom: 1rem;

    @include desktop-up {
      font-size: 1.8rem;
      line-height: 2.6rem;
    }
  }

  &__company {
    @include font-styles('Arial', 1.6rem, 200, normal, 2.2rem, 0, $dark-blue);
    margin-bottom: 1.2rem;

    @include desktop-up {
      font-size: 1.8rem;
      line-height: 2.4rem;
    }
  }

  // editmode
  &.editMode {
    @include tablet-up {
      width: 100%;
    }

    .profile-list-item__content {
      text-align: left;
    }
  }
}

.profile-list-item__image.editMode {
  img.scEnabledChrome {
    width: 20rem !important;
    height: auto !important;
  }
}
</style>
